import { render, staticRenderFns } from "./payFeeCoupon.vue?vue&type=template&id=164d57a7&scoped=true"
import script from "./payFeeCoupon.vue?vue&type=script&lang=js"
export * from "./payFeeCoupon.vue?vue&type=script&lang=js"
import style0 from "./payFeeCoupon.vue?vue&type=style&index=0&id=164d57a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164d57a7",
  null
  
)

export default component.exports